import { render, staticRenderFns } from "./specialFilmRecord.vue?vue&type=template&id=531bf3d2&scoped=true&"
import script from "./specialFilmRecord.vue?vue&type=script&lang=js&"
export * from "./specialFilmRecord.vue?vue&type=script&lang=js&"
import style0 from "./specialFilmRecord.vue?vue&type=style&index=0&id=531bf3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bf3d2",
  null
  
)

export default component.exports